import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import { DELETE_USER, GET_USERS } from '../gql/users';

const UserDelete = ({ user, open, setOpen }) => {
  const history = useHistory();
  const [deleteUser] = useMutation(DELETE_USER, {
    refetchQueries: [{ query: GET_USERS }],
    onCompleted() {
      history.push('/users');
    },
  });
  const { id, netId } = user;

  const handleDelete = () => {
    deleteUser({
      variables: { id },
    });
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-delete-user"
    >
      <DialogTitle id="dialog-delete-user">Confrim Delete</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>This action CANNOT be reversed</Typography>
        <Typography gutterBottom>
          If you just want to remove admin right of this user, please change
          it&apos;s active state.
        </Typography>
        <Typography gutterBottom>
          Do you confrim to delete admin user:
          <b>{netId}</b>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleDelete} color="primary">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

UserDelete.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    netId: PropTypes.string.isRequired,
  }).isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default UserDelete;
